'use strict';

var RomSummaryCabinChartFilterFactory = function RomSummaryCabinChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryPOSFilterFactory', 'ROMSummaryDOWFilterFactory', 'ROMSummaryRomTimeBucketFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryCabinChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'cabin-thematic-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryCabinChartFilter.constructor = RomSummaryCabinChartFilter;
  RomSummaryCabinChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryCabinChartFilter;
};
RomSummaryCabinChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryCabinChartFilterFactory;